import { volunteerPortalAccountsApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { PortalAccountApi } from "@/common/components/portal-access/portalAccess.types";

/**
 * The volunteer flavour of the shared portal-access API adapter. Volunteers have no withdraw or
 * remove-user action, and the invitation endpoint takes no body — the volunteer's single stored
 * address is used and no ID-document details are recorded, so the adapter ignores the request argument.
 */
export function createVolunteerPortalAccountApi(volunteerId: string): PortalAccountApi {
  return {
    getStatus: () => volunteerPortalAccountsApi.getVolunteerPortalAccountStatus({ volunteerId }),
    sendInvitation: () =>
      volunteerPortalAccountsApi.sendVolunteerPortalInvitation({ volunteerId }, withLocalErrorHandling),
    resendInvitation: () =>
      volunteerPortalAccountsApi.resendVolunteerPortalInvitation({ volunteerId }, withLocalErrorHandling),
    lock: () => volunteerPortalAccountsApi.lockVolunteerPortalAccount({ volunteerId }, withLocalErrorHandling),
    unlock: () => volunteerPortalAccountsApi.unlockVolunteerPortalAccount({ volunteerId }, withLocalErrorHandling),
    sendPasswordReset: () =>
      volunteerPortalAccountsApi.sendVolunteerPortalPasswordReset({ volunteerId }, withLocalErrorHandling),
  };
}
